import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ExportMetrics401,
  ExportMetricsBody,
  GetAggregatedMetrics200,
  GetAggregatedMetrics401,
  GetAggregatedMetricsParams,
  GetMetricTypes200Item,
  GetMetricTypes401,
  GetMetricsSummary200,
  GetMetricsSummary401,
  GetMetricsSummaryParams,
  QueryMetrics200Item,
  QueryMetrics401,
  QueryMetricsParams,
  TrackMetric200,
  TrackMetric401,
  TrackMetricBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Query metrics
 */
export const queryMetrics = (
    params: QueryMetricsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QueryMetrics200Item[]>(
      {url: `/api/v1/metrics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getQueryMetricsQueryKey = (params: QueryMetricsParams,) => {
    return [`/api/v1/metrics`, ...(params ? [params]: [])] as const;
    }

    
export const getQueryMetricsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof queryMetrics>>, TError = QueryMetrics401>(params: QueryMetricsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueryMetricsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof queryMetrics>>> = ({ signal }) => queryMetrics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type QueryMetricsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof queryMetrics>>>
export type QueryMetricsInfiniteQueryError = QueryMetrics401

/**
 * @summary Query metrics
 */
export const useQueryMetricsInfinite = <TData = Awaited<ReturnType<typeof queryMetrics>>, TError = QueryMetrics401>(
 params: QueryMetricsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQueryMetricsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getQueryMetricsQueryOptions = <TData = Awaited<ReturnType<typeof queryMetrics>>, TError = QueryMetrics401>(params: QueryMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQueryMetricsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof queryMetrics>>> = ({ signal }) => queryMetrics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type QueryMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof queryMetrics>>>
export type QueryMetricsQueryError = QueryMetrics401

/**
 * @summary Query metrics
 */
export const useQueryMetrics = <TData = Awaited<ReturnType<typeof queryMetrics>>, TError = QueryMetrics401>(
 params: QueryMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof queryMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getQueryMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Track a metric
 */
export const trackMetric = (
    trackMetricBody: TrackMetricBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TrackMetric200>(
      {url: `/api/v1/metrics/track`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackMetricBody
    },
      options);
    }
  


export const getTrackMetricMutationOptions = <TError = TrackMetric401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackMetric>>, TError,{data: TrackMetricBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof trackMetric>>, TError,{data: TrackMetricBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof trackMetric>>, {data: TrackMetricBody}> = (props) => {
          const {data} = props ?? {};

          return  trackMetric(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TrackMetricMutationResult = NonNullable<Awaited<ReturnType<typeof trackMetric>>>
    export type TrackMetricMutationBody = TrackMetricBody
    export type TrackMetricMutationError = TrackMetric401

    /**
 * @summary Track a metric
 */
export const useTrackMetric = <TError = TrackMetric401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof trackMetric>>, TError,{data: TrackMetricBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof trackMetric>>,
        TError,
        {data: TrackMetricBody},
        TContext
      > => {

      const mutationOptions = getTrackMetricMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get aggregated metrics
 */
export const getAggregatedMetrics = (
    params: GetAggregatedMetricsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetAggregatedMetrics200>(
      {url: `/api/v1/metrics/aggregated`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAggregatedMetricsQueryKey = (params: GetAggregatedMetricsParams,) => {
    return [`/api/v1/metrics/aggregated`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAggregatedMetricsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getAggregatedMetrics>>, TError = GetAggregatedMetrics401>(params: GetAggregatedMetricsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAggregatedMetricsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAggregatedMetrics>>> = ({ signal }) => getAggregatedMetrics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAggregatedMetricsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAggregatedMetrics>>>
export type GetAggregatedMetricsInfiniteQueryError = GetAggregatedMetrics401

/**
 * @summary Get aggregated metrics
 */
export const useGetAggregatedMetricsInfinite = <TData = Awaited<ReturnType<typeof getAggregatedMetrics>>, TError = GetAggregatedMetrics401>(
 params: GetAggregatedMetricsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAggregatedMetricsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetAggregatedMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getAggregatedMetrics>>, TError = GetAggregatedMetrics401>(params: GetAggregatedMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAggregatedMetricsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAggregatedMetrics>>> = ({ signal }) => getAggregatedMetrics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAggregatedMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getAggregatedMetrics>>>
export type GetAggregatedMetricsQueryError = GetAggregatedMetrics401

/**
 * @summary Get aggregated metrics
 */
export const useGetAggregatedMetrics = <TData = Awaited<ReturnType<typeof getAggregatedMetrics>>, TError = GetAggregatedMetrics401>(
 params: GetAggregatedMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAggregatedMetrics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAggregatedMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get metrics summary
 */
export const getMetricsSummary = (
    params: GetMetricsSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMetricsSummary200>(
      {url: `/api/v1/metrics/summary`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetMetricsSummaryQueryKey = (params: GetMetricsSummaryParams,) => {
    return [`/api/v1/metrics/summary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMetricsSummaryInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getMetricsSummary>>, TError = GetMetricsSummary401>(params: GetMetricsSummaryParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetricsSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricsSummary>>> = ({ signal }) => getMetricsSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetricsSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMetricsSummary>>>
export type GetMetricsSummaryInfiniteQueryError = GetMetricsSummary401

/**
 * @summary Get metrics summary
 */
export const useGetMetricsSummaryInfinite = <TData = Awaited<ReturnType<typeof getMetricsSummary>>, TError = GetMetricsSummary401>(
 params: GetMetricsSummaryParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetricsSummaryInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMetricsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMetricsSummary>>, TError = GetMetricsSummary401>(params: GetMetricsSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetricsSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricsSummary>>> = ({ signal }) => getMetricsSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetricsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMetricsSummary>>>
export type GetMetricsSummaryQueryError = GetMetricsSummary401

/**
 * @summary Get metrics summary
 */
export const useGetMetricsSummary = <TData = Awaited<ReturnType<typeof getMetricsSummary>>, TError = GetMetricsSummary401>(
 params: GetMetricsSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetricsSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetricsSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Export metrics
 */
export const exportMetrics = (
    exportMetricsBody: ExportMetricsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/metrics/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exportMetricsBody,
        responseType: 'blob'
    },
      options);
    }
  


export const getExportMetricsMutationOptions = <TError = ExportMetrics401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMetrics>>, TError,{data: ExportMetricsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof exportMetrics>>, TError,{data: ExportMetricsBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exportMetrics>>, {data: ExportMetricsBody}> = (props) => {
          const {data} = props ?? {};

          return  exportMetrics(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExportMetricsMutationResult = NonNullable<Awaited<ReturnType<typeof exportMetrics>>>
    export type ExportMetricsMutationBody = ExportMetricsBody
    export type ExportMetricsMutationError = ExportMetrics401

    /**
 * @summary Export metrics
 */
export const useExportMetrics = <TError = ExportMetrics401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exportMetrics>>, TError,{data: ExportMetricsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof exportMetrics>>,
        TError,
        {data: ExportMetricsBody},
        TContext
      > => {

      const mutationOptions = getExportMetricsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get available metric types
 */
export const getMetricTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMetricTypes200Item[]>(
      {url: `/api/v1/metrics/types`, method: 'GET', signal
    },
      options);
    }
  

export const getGetMetricTypesQueryKey = () => {
    return [`/api/v1/metrics/types`] as const;
    }

    
export const getGetMetricTypesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getMetricTypes>>, TError = GetMetricTypes401>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetricTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricTypes>>> = ({ signal }) => getMetricTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetricTypesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMetricTypes>>>
export type GetMetricTypesInfiniteQueryError = GetMetricTypes401

/**
 * @summary Get available metric types
 */
export const useGetMetricTypesInfinite = <TData = Awaited<ReturnType<typeof getMetricTypes>>, TError = GetMetricTypes401>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetricTypesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetMetricTypesQueryOptions = <TData = Awaited<ReturnType<typeof getMetricTypes>>, TError = GetMetricTypes401>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetricTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricTypes>>> = ({ signal }) => getMetricTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMetricTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getMetricTypes>>>
export type GetMetricTypesQueryError = GetMetricTypes401

/**
 * @summary Get available metric types
 */
export const useGetMetricTypes = <TData = Awaited<ReturnType<typeof getMetricTypes>>, TError = GetMetricTypes401>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMetricTypes>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMetricTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



